export const ROUTE_PATHS = {
  HOME: '/',
  PROPERTIES: '/properties',
  PROPERTY_DETAIL: '/property/:id',
  INVESTMENT: '/investment',
  ABOUT: '/about',
  CONTACT: '/contact',
  ADMIN: '/admin',
  ADMIN_LOGIN: '/admin/login',
  ADMIN_DASHBOARD: '/admin/dashboard',
  ADMIN_PROPERTIES: '/admin/properties',
  ADMIN_PROPERTIES_NEW: '/admin/properties/new',
  ADMIN_PROPERTIES_EDIT: '/admin/properties/:id/edit',
  ADMIN_CATEGORIES: '/admin/categories',
  ADMIN_FILES: '/admin/files',
  ADMIN_SETTINGS: '/admin/settings',
} as const;

export const WHATSAPP_NUMBER = '+255658984616';
export const CONTACT_EMAIL = 'info@anchorvaultestate.com';
export const CONTACT_PHONE = '+255658984616';

export type PropertyType = 'Plot' | 'Villa' | 'Condominium' | 'Project';
export type PropertyStatus = 'Available' | 'Sold' | 'Reserved';

export interface Property {
  id: string;
  title: string;
  type: PropertyType;
  category?: string;
  price: number;
  location: string;
  description: string;
  features: string[];
  images: string[];
  status: PropertyStatus;
  featured: boolean;
  badge?: string;
}

export interface ContactFormData {
  name: string;
  email: string;
  phone: string;
  interest: string;
  message: string;
}

export interface SiteSettings {
  key: string;
  value: string;
}

export interface Category {
  id: string;
  name: string;
  description: string;
  slug: string;
  active: boolean;
  display_order: number;
}

export interface ContactSubmission {
  id: string;
  name: string;
  email: string;
  phone: string;
  interest: string;
  message: string;
  created_at: string;
}

export interface AdminUser {
  id: string;
  username: string;
  role: string;
}
